export default __webpack_public_path__ + "static/6-4b5f08e03509d6a6cab4a481e2d9244b.webp";